import { zzsh } from '@/axios'
import { Message } from 'element-ui'

let that;
export default {
	data(){
		return{
			formData:{
				title:"数据加载中",
				uid1:"数据加载中",
				day:"数据加载中",
				gu_name:"数据加载中",
				u_zuzhi:"数据加载中",
				name2:"数据加载中",
				address:"数据加载中",
				content:"数据加载中",
				files:[]
			}
		}
	},
	methods:{
		//获取数据
		bindData(){
			zzsh.updateOrganTalkGet({
				id:that.$route.query.id
			}).then(res => {
				if(res.code == 200){
					for(let key in res.data){
						for(let index in that.formData){
							if(key === index){
								if(res.data[index]){
									that.formData[key] = res.data[index];
								}else{
									that.formData[key] = "待填写";
								}
							}
						}
					}
					console.log(that.formData)
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		downloadFile(file){
			// 文件下载
			if(file){
				location.href=file
			}else{
				Message({
					type:"error",
					message:"下载失败"
				})
			}
		}
	},
	mounted() {
		that.bindData();
	},
	created(){
		that = this;
	},
}